var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex font-medium",class:{ 'flex-col': _vm.flexCol }},[_c('b',{staticClass:"text-xs"},[_vm._v(_vm._s(_vm.description)+":")]),_vm._v(" "),_c('div',{staticClass:"pl-2"},[_vm._v("\n      "+_vm._s(_vm.value)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }